export const SidebarContainer = (props: {
  children?: React.ReactNode;
  className?: string;
}) => {
  const { children } = props;

  return (
    <aside className="l-sidebar l-sidebar--airy col-auto">
      <dl className="c-item-list flex-column">{children}</dl>
    </aside>
  );
};
